/*
 * shared Sagas
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 01-Feb-2023
 */

import { put, call, all, takeLatest } from 'redux-saga/effects';
import * as apiStore from 'Api/store/store';
import * as apiGroup from 'Api/groups/groups';
import * as apiMerchant from 'Api/merchant/merchant';
import * as apiTransaction from 'Api/transactions/transactions';
import * as actionShared from '../actions/shared';
// import { delay } from 'Store/sagas/index';

// STORE
function* storeList(action) {
	const { error, response } = yield call(apiStore.listStores, { ...action.request });

	if (!error) {
		yield put(actionShared.listStores.success(response.data));
	} else {
		yield put(actionShared.listStores.failure(error));
	}
}

function* storeFind(action) {
	const { error, response } = yield call(apiStore.findStore, { ...action.request });

	if (!error) {
		yield put(actionShared.findStore.success(response.data));
	} else {
		yield put(actionShared.findStore.failure(error));
	}
}

// GROUP
function* groupList(action) {
	const { error, response } = yield call(apiGroup.groupList, { ...action.request });

	if (!error) {
		yield put(actionShared.fetchGroupList.success(response.data));
	} else {
		yield put(actionShared.fetchGroupList.failure(error, response));
	}
}

function* groupFind(action) {
	const { error, response } = yield call(apiGroup.groupFind, { ...action.request });

	if (!error) {
		yield put(actionShared.fetchGroupFind.success(response.data));
	} else {
		yield put(actionShared.fetchGroupFind.failure(error, response));
	}
}

// MERCHANT
function* merchantList(action) {
	const { error, response } = yield call(apiMerchant.merchantList, { ...action.request });

	if (!error) {
		yield put(actionShared.fetchMerchantList.success(response.data));
	} else {
		yield put(actionShared.fetchMerchantList.failure(error));
	}
}

function* merchantFind(action) {
	const { error, response } = yield call(apiMerchant.merchantFind, { ...action.request });

	if (!error) {
		yield put(actionShared.fetchMerchantFind.success(response.data));
	} else {
		yield put(actionShared.fetchMerchantFind.failure(error));
	}
}

// TRANSACTION
function* transactionList(action) {
	const { error, response } = yield call(apiTransaction.transactionList, { ...action.request });

	if (!error) {
		yield put(actionShared.fetchTransactionList.success(response.data));
	} else {
		yield put(actionShared.fetchTransactionList.failure(error, response));
	}
}

function* transactionFind(action) {
	const { error, response } = yield call(apiTransaction.transactionFind, { ...action.request });

	if (!error) {
		yield put(actionShared.fetchTransactionFind.success(response.data));
	} else {
		yield put(actionShared.fetchTransactionFind.failure(error, response));
	}
}

// @generator saga

function* watchStoreList() {
	yield takeLatest(actionShared.actionTypes.LIST_STORES_REQUEST, storeList);
}

function* watchStoreFind() {
	yield takeLatest(actionShared.actionTypes.FIND_STORE_REQUEST, storeFind);
}

function* watchGroupList() {
	yield takeLatest(actionShared.actionTypes.FETCH_GROUP_LIST_REQUEST, groupList);
}

function* watchGroupFind() {
	yield takeLatest(actionShared.actionTypes.FETCH_GROUP_FIND_REQUEST, groupFind);
}

function* watchMerchantList() {
	yield takeLatest(actionShared.actionTypes.FETCH_MERCHANT_LIST_REQUEST, merchantList);
}

function* watchMerchantFind() {
	yield takeLatest(actionShared.actionTypes.FETCH_MERCHANT_FIND_REQUEST, merchantFind);
}

function* watchTransactionFind() {
	yield takeLatest(actionShared.actionTypes.FETCH_TRANSACTION_FIND_REQUEST, transactionFind);
}

function* watchTransactionList() {
	yield takeLatest(actionShared.actionTypes.FETCH_TRANSACTION_LIST_REQUEST, transactionList);
}

// @generator saga:watch

/**
 * Root saga manages watcher lifecycle
 */
export default function* rootSaga() {
	yield all([
		watchStoreList(),
		watchStoreFind(),
		watchGroupList(),
		watchGroupFind(),
		watchMerchantList(),
		watchMerchantFind(),
		watchTransactionList(),
		watchTransactionFind(),
		// @generator saga:fork
	]);
}
